export default __webpack_public_path__ + "static/media/callLogIcon.3f9cb09d.svg";